/**
 * Here are helper functions that will be used by caller to generate the signature
 */

import _ from 'lodash';
import DateUtil from '../common/dateUtil';
import Util from '../common/util';

const buildStringToSign = (
  { method, pathWithQuery, bodyHashB64, ts },
) => `${method.toUpperCase()}:${pathWithQuery}:${bodyHashB64}:${ts}`;

const base64ToBytes = (b64) => Buffer.from(b64, 'base64');

const abToBase64 = (buf) => Buffer.from(buf, 'utf8').toString('base64');

const importHmacKey = async (base64Key) => {
  const rawKey = base64ToBytes(base64Key); // **decode once** to raw bytes
  return window.crypto.subtle.importKey(
    'raw',
    rawKey,
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign', 'verify'],
  );
};

const sha256Base64 = async (str) => {
  const enc = new TextEncoder();
  const buf = await window.crypto.subtle.digest('SHA-256', enc.encode(str));
  return abToBase64(buf);
};

// This is to hash the file (photo, video, etc) used for signing signature.
export const hashFile = async (file) => {
  const buf = await file.arrayBuffer();
  const digest = await window.crypto.subtle.digest('SHA-256', buf);
  return btoa(String.fromCharCode(...new Uint8Array(digest)));
};

export const signRequest = async ({ base64Key, method, pathWithQuery, bodyObj }) => {
  try {
    let bodyCloned = _.cloneDeep(bodyObj);
    // We need to convert all values to a string
    bodyCloned = Util.stringifyObjectValuesForUrl(bodyCloned);
    const bodyString = bodyCloned ? JSON.stringify(bodyCloned) : '';
    const bodyHashB64 = await sha256Base64(bodyString);
    const timestamp = Math.floor(DateUtil.GetCurrentDate() / 1000); // UNIX seconds

    const key = await importHmacKey(base64Key);

    const stringToSign = buildStringToSign({ method, pathWithQuery, bodyHashB64, ts: timestamp });
    const enc = new TextEncoder();
    const sigBuf = await window.crypto.subtle.sign('HMAC', key, enc.encode(stringToSign));
    const signature = abToBase64(sigBuf);

    return { signature, timestamp, bodyString };
  } catch (err) {
    console.log('Exception in signRequest(): ', err);
  }
};

const signatureUtil = {
  hashFile,
  signRequest,
};

export default signatureUtil;
